// eslint-disable-next-line no-restricted-imports
import type { UseFormReturn } from 'react-hook-form';
import { createContext } from 'react';

import type { SubmitHandler } from './type';

export interface LunaFormContextValue<FormValue extends Record<string, any> = Record<string, any>> {
    onSubmit?: SubmitHandler<FormValue>;
    form?: UseFormReturn<FormValue>;
    autoScrollToError: boolean;
    autoFocusOnError: boolean;
}

export const LunaFormContext = createContext<LunaFormContextValue>({
    autoScrollToError: true,
    autoFocusOnError: true,
});
